/**
 * Convierte la primera letra de una cadena a Mayuscula
 * @param {string} string - Cadena de texto a la cual se le convertira la primera letra a mayuscula
 * @returns {string} Cadena con la primera letra en mayuscula
 */
export async function primeraLetraMayus(string) {
   return await (string.charAt(0).toUpperCase() + string.slice(1));
}

/**
 * Convierte la primera letra de una cadena a Minuscula
 * @param {string} string - Cadena de texto a la cual se le convertira la primera letra a mayuscula
 * @returns {string} Cadena con la primera letra en mayuscula
 */
export async function primeraLetraMinus(string) {
   return await (string.charAt(0).toLowerCase() + string.slice(1));
}

/**
 * Rellena un cadena de texto con un caracter dado a la izq o a la derecha segun se le indique
 * @param {string} - Cadena cadena a la cual se le rellenara
 * @param {number} longitud - Nro entero que ayuda a validar el tamanio de la cadena
 * @param {char} caracter - Caracter con el cual se llenara la cadena
 * @param {boolean} izq - Variable boolena que indica hacia que lado de la cadena se rellenara
 * @returns {cadena} Cadena conpletada con @caracter
 */
async function rellenarStr(cadena, longitud, caracter, izq) {
   if (cadena.length <= longitud) {
      const relleno = new Array(longitud - cadena.length + 1).join(caracter);
      if (izq) {
         return relleno + cadena;
      } else {
         return cadena + relleno;
      }
   }
   return cadena;
}
/**
 * Rellena una cadena de texto hacia el lado izquierdo con una caracter dado
 * @param {string} cadena - Cadena de texto que se rellenara con el @caracter dado
 * @param {number} longitud - Numero que nos ayudara a validar la longitud de la cadena
 * @param {char} caracter - Caracter con el cual llenaremos la cadena hacia el lado corespondiente
 * @returns {cadena} Cadena conpletada con @caracter hacia el lado izquierdo
 */
export async function rellenarStrIzq(cadena, longitud, caracter) {
   return rellenarStr(cadena, longitud, caracter, true);
}

/**
 * Rellena una cadena de texto hacia el lado derecho con una caracter dado
 * @param {string} cadena - Cadena de texto que se rellenara con el @caracter dado
 * @param {number} longitud - Numero que nos ayudara a validar la longitud de la cadena
 * @param {char} caracter - Caracter con el cual llenaremos la cadena hacia el lado corespondiente
 * @returns {cadena} Cadena conpletada con @caracter hacia el lado derecho
 */
export async function rellenarStrDer(cadena, longitud, caracter) {
   return rellenarStr(cadena, longitud, caracter, false);
}
/**
 * Remplaza 2 espacios juntos por el caracter dado, por defecto es un solo espacio, en una cadena de texto
 * @param {string} cadena - Cadena que se le reemplazara los 2 espacios por un carater
 * @param {string} caracter - Caracter la cual reemplazara a los espacios
 * @returns cadena con todos los espacios reemplazados con el @caracter
 */
export function reemplazarMultiplesSpacios(cadena, caracter = ' ') {
   return cadena.replace(/\s\s+/g, caracter);
}

/**
 * Elimina todos los espacios en una cadena de texto
 * @param {string} cadena - Cadena que se le reemplazara los 2 espacios por un carater
 * @returns cadena con todos los espacios eliminados
 */
export function removeSpaces(cadena) {
   return cadena.replace(/\s/g, '');
}
/**
 * Retorna la subcadena dentro de __baseString__ a partir de la primera aparicion de __char_
 * @param {string} baseString - Cadena base sobre la cual se desea realizar la busqueda
 * @param {string} char - Separador a partir del cual se retornara la subcadena
 * @returns subcadena
 */
export function getSubstringAfterChar(baseString, char) {
   if (baseString) {
      const re = new RegExp(`${char}(.*)`, 's');
      return baseString.split(re)[1];
   }
   return null;
}
